// pages/BoilerRepair.jsx


import RepairHero from "../components/boilerRepair/RepairHero";
import RepairWhy from "../components/boilerRepair/RepairWhy";
import FAQ from "../components/boilerService/FAQ";
import Trust from "../components/home/Trust";


const BoilerRepair = () => {
  return (
    <>
      <RepairHero />
      <Trust/>
      <RepairWhy />
      <FAQ />
    
    </>
  );
};

export default BoilerRepair;